import { createAction } from '@reduxjs/toolkit';

import type { UseAppSearchParamsResult } from 'utils/url/useAppSearchParams';

const prefix = 'dashboard';

export const dashboardActions = {
  setLastSearchParams: createAction<{
    params: UseAppSearchParamsResult<'/dashboard/queues'>['params'];
  }>(`${prefix}/setLastSearchParams`),
};
